<template>
  <div
    id="app"
    class="global-layout nav-global "
  >
    <BetaBanner/>
    <!-- Mobile Logo Header -->
    <div class="mobile-logo-header d-flex d-xl-none">
      <b-container class="d-flex justify-content-center align-items-center">
        <router-link :to="{ name: 'home' }" class="navbar-brand">
          <svg-icon
            aria-label="caerus logo, click to go to home page"
            name="caerus-logo-navbar-light"
            width="122"
            role="button"
          />
          <span class="sr-only">Navigate to home</span>
        </router-link>
      </b-container>
    </div>
    <Navbar />
    <!-- https://github.com/mbj36/vue-burger-menu -->
    <div id="page-wrap">
      <router-view />
    </div>

    <!-- Filter Sidebar - Rendered outside navbar to escape stacking context -->
    <FilterSidebar />
  </div>
</template>

<script>
import Navbar from '@/core/layouts/global-layout/components/Navbar'
import BetaBanner from '@/core/layouts/global-layout/components/BetaBanner'
import FilterSidebar from '@/core/layouts/global-layout/components/FilterSidebar'
import '@/core/icons/caerus-logo-navbar-light'

export default {

  components: {
    Navbar,
    BetaBanner,
    FilterSidebar
  },

  // Store reference on $root for easy access
  beforeCreate() {
    this.$root.$filterSidebar = this
  },

  data() {
    return {
      filterSidebarVisible: false,
      filterParams: {
        postcode: '',
        service_type_id: '',
        date: '',
        search: ''
      },
      advancedFilters: {}
    }
  },

  watch: {
    '$route.query'(query) {
      this.filterParams = {
        postcode: query.postcode || '',
        service_type_id: query.service_type_id || '',
        date: query.date || '',
        search: query.search || ''
      }
    }
  },

  methods: {
    openFilterSidebar() {
      this.filterSidebarVisible = true
    },

    closeFilterSidebar() {
      this.filterSidebarVisible = false
    },

    updateFilterParams(params) {
      this.filterParams = { ...this.filterParams, ...params }
    },

    applyFilters(advancedFilters) {
      // Combine basic and advanced filters
      const allFilters = {
        ...this.filterParams,
        ...advancedFilters,
        page: 1 // Reset to first page
      }

      // Remove empty values
      Object.keys(allFilters).forEach(key => {
        if (allFilters[key] === '' || allFilters[key] === null || 
            (Array.isArray(allFilters[key]) && allFilters[key].length === 0)) {
          delete allFilters[key]
        }
      })

      // Navigate to search results with filters
      this.$router.push({
        name: 'search-results',
        query: allFilters
      })

      // Close sidebar
      this.filterSidebarVisible = false
    },

    clearFilters() {
      this.filterParams = {
        postcode: '',
        service_type_id: '',
        date: '',
        search: ''
      }
      this.advancedFilters = {}
      
      // Navigate to search results with no filters
      this.$router.push({
        name: 'search-results',
        query: {}
      })

      // Close sidebar
      this.filterSidebarVisible = false
    }
  }
}
</script>
<style lang="scss">
@media only screen and (max-width: 576px) {
  .nav-global {
    width: 100%;
  }
}

.mobile-logo-header {
  background: $white;
  border-bottom: 1px solid $border-gray;
  padding: 12px 0;
  min-height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;

  .navbar-brand {
    margin: 0;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
